import { z } from 'zod';
/** The 402 body every gated router answers when the organisation's access has lapsed. */
export const AccessDenied = z.object({
    error: z.literal('access_lapsed'),
    message: z.string(),
    state: z.enum(['trial', 'active', 'lapsed']),
    trialEndsAt: z.string().nullable(),
});
//# sourceMappingURL=errors.js.map